var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartPieSlice = function SvgChartPieSlice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#161D25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 16.333v-12M26.388 10.333l-20.775 12M4.2 18.533a11.6 11.6 0 0 1-.2-2.2 11.99 11.99 0 0 1 8-11.312v9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#161D25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 4.333A12 12 0 1 1 5.65 22.408"
  })));
};
export default SvgChartPieSlice;